import { BuscaPaginada } from './../model/busca-paginada';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { Documento } from '../model/documento';
import { QuantidadeInvestidores } from '../model/quantidade-investidores';
import { Rodada } from '../model/rodada';
import { ValorCaptadoPorRodada } from '../model/valor-captado';
import { ListaPaginada } from '../model/lista-paginada';
import { ParametrosPaginacao } from '../model/interface/parametros-paginacao';
import { RespostaHttp } from '../model/resposta-http';
import { DescricaoRodada } from '../model/descricao-rodada';
import { CadastroRodada } from '../model/interface/cadastro-rodada-interface';
import { environment } from '../../../../environments/environment';
import { PrimecapUtils } from '../../../utils/primecap-utils';

@Injectable({
  providedIn: 'root'
})
export class RodadasCoreService {
  constructor(private http: HttpClient) {}

  getRodadaPorUuid(
    empresaUuid: string,
    rodadaUuid: string
  ): Observable<RespostaHttp<BuscaPaginada<Rodada>>> {
    return this.http
      .get<RespostaHttp<BuscaPaginada<Rodada>>>(
        `${environment.apiUrl}/empresas/${empresaUuid}/rodadas/${rodadaUuid}`
      )
      .pipe(take(1));
  }

  getRodadas(
    paginacao: ParametrosPaginacao
  ): Observable<RespostaHttp<ListaPaginada<Rodada>>> {
    let url: string = `${environment.apiUrl}/empresas/rodadas`;
    if (paginacao.tamanhoPagina != null && paginacao.indicePagina != null) {
      url = url.concat(
        `?size=${paginacao.tamanhoPagina}&page=${paginacao.indicePagina}`
      );
    } else if (paginacao.tamanhoPagina != null) {
      url = url.concat(`?size=${paginacao.tamanhoPagina}`);
    }
    return this.http.get<RespostaHttp<ListaPaginada<Rodada>>>(url);
  }

  getRodadasHome(
    paginacao: ParametrosPaginacao
  ): Observable<RespostaHttp<ListaPaginada<Rodada>>> {
    let url: string = `${environment.apiUrl}/empresas/rodadas/home`;
    if (paginacao.tamanhoPagina != null && paginacao.indicePagina != null) {
      url = url.concat(
        `?size=${paginacao.tamanhoPagina}&page=${paginacao.indicePagina}`
      );
    } else if (paginacao.tamanhoPagina != null) {
      url = url.concat(`?size=${paginacao.tamanhoPagina}`);
    }
    return this.http
      .get<RespostaHttp<ListaPaginada<Rodada>>>(url)
      .pipe(take(1));
  }

  getRodadasPorStatus(
    statusRodada: string,
    paginacao: ParametrosPaginacao
  ): Observable<RespostaHttp<ListaPaginada<Rodada>>> {
    let url: string = `${environment.apiUrl}/empresas/rodadas?statusRodada=${statusRodada}`;
    if (paginacao.tamanhoPagina != null && paginacao.indicePagina != null) {
      url = url.concat(
        `&size=${paginacao.tamanhoPagina}&page=${paginacao.indicePagina}`
      );
    } else if (paginacao.tamanhoPagina != null) {
      url = url.concat(`&size=${paginacao.tamanhoPagina}`);
    }
    return this.http
      .get<RespostaHttp<ListaPaginada<Rodada>>>(url)
      .pipe(take(1));
  }

  getRodadasPorTipo(
    tipoRodada: string,
    paginacao: ParametrosPaginacao
  ): Observable<RespostaHttp<ListaPaginada<Rodada>>> {
    let url: string = `${environment.apiUrl}/empresas/rodadas/tipo?tipoRodada=${tipoRodada}`;
    if (paginacao.tamanhoPagina != null && paginacao.indicePagina != null) {
      url = url.concat(
        `&size=${paginacao.tamanhoPagina}&page=${paginacao.indicePagina}`
      );
    } else if (paginacao.tamanhoPagina != null) {
      url = url.concat(`&size=${paginacao.tamanhoPagina}`);
    }
    return this.http
      .get<RespostaHttp<ListaPaginada<Rodada>>>(url)
      .pipe(take(1));
  }

  getRodadasPorEmpresa(
    empresaUuid: string,
    paginacao: ParametrosPaginacao
  ): Observable<RespostaHttp<ListaPaginada<Rodada>>> {
    let url: string = `${environment.apiUrl}/empresas/${empresaUuid}/rodadas`;
    if (paginacao.tamanhoPagina != null && paginacao.indicePagina != null) {
      url = url.concat(
        `?size=${paginacao.tamanhoPagina}&page=${paginacao.indicePagina}`
      );
    } else if (paginacao.tamanhoPagina != null) {
      url = url.concat(`?size=${paginacao.tamanhoPagina}`);
    }
    return this.http
      .get<RespostaHttp<ListaPaginada<Rodada>>>(url)
      .pipe(take(1));
  }

  getRodadasPorEmpresaETipo(
    empresaUuid: string,
    tipoRodada: string,
    paginacao: ParametrosPaginacao
  ): Observable<RespostaHttp<ListaPaginada<Rodada>>> {
    let url: string = `${environment.apiUrl}/empresas/${empresaUuid}/rodadas/tipo?tipoRodada=${tipoRodada}`;
    if (paginacao.tamanhoPagina != null && paginacao.indicePagina != null) {
      url = url.concat(
        `&size=${paginacao.tamanhoPagina}&page=${paginacao.indicePagina}`
      );
    } else if (paginacao.tamanhoPagina != null) {
      url = url.concat(`&size=${paginacao.tamanhoPagina}`);
    }
    return this.http
      .get<RespostaHttp<ListaPaginada<Rodada>>>(url)
      .pipe(take(1));
  }

  postRodada(
    rodada: Rodada,
    empresaUuid: string
  ): Observable<RespostaHttp<Rodada>> {
    rodada.feeNegociado = PrimecapUtils.dividirValorPorCem(rodada.feeNegociado);
    rodada.rentabilidadeOferecida = PrimecapUtils.dividirValorPorCem(
      rodada.rentabilidadeOferecida
    );
    rodada.equityOferecido = PrimecapUtils.dividirValorPorCem(
      rodada.equityOferecido
    );
    return this.http
      .post<RespostaHttp<Rodada>>(
        `${environment.apiUrl}/empresas/${empresaUuid}/rodadas`,
        new CadastroRodada(rodada)
      )
      .pipe(take(1));
  }

  putRodada(
    rodada: Rodada,
    rodadaUuid: string,
    empresaUuid: string
  ): Observable<RespostaHttp<Rodada>> {
    rodada.feeNegociado = PrimecapUtils.dividirValorPorCem(rodada.feeNegociado);
    rodada.rentabilidadeOferecida = PrimecapUtils.dividirValorPorCem(
      rodada.rentabilidadeOferecida
    );
    rodada.equityOferecido = PrimecapUtils.dividirValorPorCem(
      rodada.equityOferecido
    );
    return this.http
      .put<RespostaHttp<Rodada>>(
        `${environment.apiUrl}/empresas/${empresaUuid}/rodadas/${rodadaUuid}`,
        rodada
      )
      .pipe(take(1));
  }

  deleteRodada(
    rodadaUuid: string,
    empresaUuid: string
  ): Observable<RespostaHttp<Rodada>> {
    return this.http
      .delete<RespostaHttp<Rodada>>(
        `${environment.apiUrl}/empresas/${empresaUuid}/rodadas/${rodadaUuid}`
      )
      .pipe(take(1));
  }

  getValorCaptadoPorRodada(
    empresaUuid: string,
    rodadaUuid: string
  ): Observable<ValorCaptadoPorRodada> {
    return this.http
      .get<ValorCaptadoPorRodada>(
        `${environment.apiUrl}/empresas/${empresaUuid}/rodadas/${rodadaUuid}/graficos/valor-captado-por-rodada`
      )
      .pipe(take(1));
  }

  getQuantidadeInvestidoresPorRodada(
    empresaUuid: string,
    rodadaUuid: string
  ): Observable<RespostaHttp<QuantidadeInvestidores>> {
    return this.http
      .get<RespostaHttp<QuantidadeInvestidores>>(
        `${environment.apiUrl}/empresas/${empresaUuid}/rodadas/${rodadaUuid}/graficos/quantidade-investidores-por-rodada`
      )
      .pipe(take(1));
  }

  getDocumentosRodadaPorUuid(
    empresaUuid: string,
    rodadaUuid: string,
    paginacao: ParametrosPaginacao
  ): Observable<RespostaHttp<ListaPaginada<Documento>>> {
    let url = `${environment.apiUrl}/empresas/${empresaUuid}/rodadas/${rodadaUuid}/documentos`;
    if (paginacao.tamanhoPagina && paginacao.indicePagina) {
      url = url.concat(
        `?size=${paginacao.tamanhoPagina}&page=${paginacao.indicePagina}`
      );
    } else {
      url = url.concat(`?size=${paginacao.tamanhoPagina}`);
    }
    return this.http
      .get<RespostaHttp<ListaPaginada<Documento>>>(url, {
        headers: { intercept: 'true' }
      })
      .pipe(take(1));
  }

  getDescricoesRodadaPorUuid(
    empresaUuid: string,
    rodadaUuid: string,
    paginacao: ParametrosPaginacao
  ): Observable<RespostaHttp<ListaPaginada<DescricaoRodada>>> {
    let url = `${environment.apiUrl}/empresas/${empresaUuid}/rodadas/${rodadaUuid}/descricoes`;
    if (paginacao.tamanhoPagina && paginacao.indicePagina) {
      url = url.concat(
        `?size=${paginacao.tamanhoPagina}&page=${paginacao.indicePagina}`
      );
    } else {
      url = url.concat(`?size=${paginacao.tamanhoPagina}`);
    }
    return this.http
      .get<RespostaHttp<ListaPaginada<DescricaoRodada>>>(url, {
        headers: { intercept: 'true' }
      })
      .pipe(take(1));
  }

  putDocumentosRodada(
    documentos: Documento[],
    empresaUuid: string,
    rodadaUuid: string
  ): Observable<Documento[]> {
    return this.http
      .put<Documento[]>(
        `${environment.apiUrl}/empresas/${empresaUuid}/rodadas/${rodadaUuid}/documentos`,
        documentos
      )
      .pipe(take(1));
  }
}
